import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaFont } from 'react-icons/fa';

const TextUI = ({
  questionId,
  answerTexts,
  setAnswerTexts,
  handleInputChange,
  MySwal,
  isSimulation = false
}) => {
  const { t } = useTranslation();
  const hasText = answerTexts[questionId];
  
  // Function to handle text input
  const handleTextInput = (questionId, text) => {
    setAnswerTexts(prev => ({
      ...prev,
      [questionId]: text
    }));
  };
  
  if (hasText) {
    return (
      <div className="mt-3 mb-0">
        <div className="card">
          <div className="card-body p-3">
            <div className="d-flex align-items-center">
              <FaFont className="me-2" size={18} color="#6c757d" />
              <div className="flex-grow-1">
                <h6 className="mb-0">{t('providedText', { ns: 'labels' })}</h6>
                <p className="mb-0 text-break">{answerTexts[questionId]}</p>
              </div>
              <button 
                type="button" 
                className="btn btn-sm btn-outline-danger ms-2"
                onClick={() => {
                  // Remove text
                  setAnswerTexts(prev => {
                    const newTexts = {...prev};
                    delete newTexts[questionId];
                    return newTexts;
                  });
                }}
              >
                <i className="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="mt-3 mb-0">
      <div className="input-group">
        <span className="input-group-text">
          <FaFont />
        </span>
        <textarea 
          className="form-control" 
          placeholder={t('enterText', { ns: 'labels' })}
          id={`text-input-${questionId}`}
          rows="3"
        ></textarea>
      </div>
      <div className="d-flex justify-content-end mt-2">
        <button 
          className="btn btn-outline-primary btn-sm"
          type="button"
          onClick={() => {
            const textInput = document.getElementById(`text-input-${questionId}`);
            const text = textInput.value.trim();
            
            if (text) {
              handleTextInput(questionId, text);
              
              // Show success message
              MySwal.fire({
                title: t('textAdded', { ns: 'labels' }),
                icon: 'success',
                timer: 1500,
                showConfirmButton: false
              });
            }
          }}
        >
          {t('save', { ns: 'labels' })}
        </button>
      </div>
    </div>
  );
};

export default TextUI; 